import i18n from '@/i18n';
import {EventSubType} from '@/services/graphqlHooks';

const eventSubTypes = {
  [EventSubType.Hospital]: i18n.t('Hospital'),
  [EventSubType.Illness]: i18n.t('Illness'),
  [EventSubType.MedicalAbnormality]: i18n.t('MedicalAbnormality'),
  [EventSubType.MedicalAppointment]: i18n.t('MedicalAppointment'),
  [EventSubType.Treatment]: i18n.t('Treatment'),
  [EventSubType.None]: i18n.t('None'),
} as Record<EventSubType, string>;

export default eventSubTypes;
